export { default } from '@routine-notes/ui/utils/getJSON';
